export default (userPromos) => ({
  type: "PROMOS_LIST_SET",
  payload: userPromos
});

export const setPromoWidgetModalStateAction = (value) => ({
  type: "SET_PROMO_WIDGET_MODAL_STATE",
  payload: value
});
